import { FormTextareaRecord } from '@interfaces';

interface FormTextareaProps
	extends Omit<FormTextareaRecord, '__typename' | 'id'> {
	className?: string;
}

export const FormTextarea = ({
	className,
	isRequired,
	label,
	name,
}: FormTextareaProps) => {
	return (
		<textarea
			aria-label={label}
			className={className}
			name={name}
			placeholder={isRequired ? `${label}\u202F*` : label}
			required={isRequired}
			rows={3}
		/>
	);
};
